<!--
 * @Descripttion: 广告详情
 * @Author: liaoyijun
 * @Date: 2021-10-22 14:00:01
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-11-03 15:46:08
-->
<template>
    <div class="center-context-item">
        <div class="center">
            <div class="center-context-title">
                <span>{{ curDetails.title }}</span>
            </div>
            <div class="center-context-time">
                <span>发布时间</span><span> {{ curDetails.updateDate }}</span>
            </div>
            <div class="editor-content" v-html="curDetails.mainBody"></div>
        </div>
    </div>
</template>

<script>
import { advDetails } from "@/api";
export default {
    name: "AdvDetails",
    data() {
        return {
            curDetails: {},
        };
    },
    mounted() {
        this.advDetails();
    },
    activated() {
        this.advDetails();
    },
    methods: {
        // 获取福利详情
        async advDetails() {
            this.loading = true;
            try {
                const { code, body, message } = await advDetails(this.$route.query.id);
                if (code === "0000") {
                    this.curDetails = body;
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                this.$message.error("系统错误");
            }
            this.loading = false;
        },
    },
};
</script>
<style lang="scss" scoped>
@import "../style.scss";
</style>
